export default __webpack_public_path__ + "static/media/partner.d2de1238.png";